import { ReactComponent as FlagIcon } from "./svg/kz-flag.svg";
import "../flag-icon.scss";

export const KZFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
